import axios from 'axios';
import { initializeApp, getApps } from 'firebase/app';
import { getMessaging, getToken, deleteToken, isSupported, onMessage } from 'firebase/messaging';
import { API } from './api';

const config = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};
export const pushConfigured = Boolean(config.apiKey && config.projectId && config.messagingSenderId && config.appId && process.env.REACT_APP_FIREBASE_VAPID_KEY);
let messaging;
let unsubscribe;
let queue = Promise.resolve();
let activeOwner;
const serial = (fn) => { queue = queue.catch(() => {}).then(fn); return queue; };
const headers = (owner) => ({ Authorization: `Bearer ${owner.token}`, 'X-Notification-Role': owner.role });
function installation() {
  let id = localStorage.getItem('repairro_push_installation');
  if (!id) { id = crypto.randomUUID(); localStorage.setItem('repairro_push_installation', id); }
  return id;
}
async function setup() {
  if (!pushConfigured || !(await isSupported())) return null;
  if (!messaging) messaging = getMessaging(getApps()[0] || initializeApp(config));
  const params = new URLSearchParams({ config: JSON.stringify(config) });
  const registration = await navigator.serviceWorker.register(`/firebase-messaging-sw.js?${params}`);
  await navigator.serviceWorker.ready;
  if (!unsubscribe) unsubscribe = onMessage(messaging, ({ data }) => {
    registration.active?.postMessage({ type: 'SHOW_NOTIFICATION', data });
  });
  return registration;
}
export function refreshPush(owner) {
  return serial(async () => {
    if (!pushConfigured || !('Notification' in window) || Notification.permission !== 'granted') return false;
    const registration = await setup();
    if (!registration) return false;
    const token = await getToken(messaging, { vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY, serviceWorkerRegistration: registration });
    if (!token) return false;
    const { data } = await axios.put(`${API}/notifications/devices`, { token, installation_id: installation(), platform: 'web' }, { headers: headers(owner) });
    registration.active?.postMessage({ type: "SET_OWNER", owner: data.owner });
    activeOwner = owner;
    return true;
  });
}
export async function enablePush(owner) {
  if (!('Notification' in window)) throw new Error('This browser does not support notifications.');
  if (await Notification.requestPermission() !== 'granted') throw new Error('Allow notifications in your browser settings to enable booking alerts.');
  if (!(await refreshPush(owner))) throw new Error('Push notifications are unavailable in this browser.');
}
export function disablePush(owner) {
  return serial(async () => {
    if (!owner?.token) return;
    const id = localStorage.getItem('repairro_push_installation');
    const registration = await navigator.serviceWorker?.getRegistration();
    if (!activeOwner || activeOwner.role === owner.role) registration?.active?.postMessage({ type: 'CLEAR_OWNER' });
    try {
      if (id) await axios.delete(`${API}/notifications/devices/${id}`, { headers: headers(owner), timeout: 5000 });
    } finally {
      if (!activeOwner || activeOwner.role === owner.role) {
        if (!messaging && pushConfigured && await isSupported()) messaging = getMessaging(getApps()[0] || initializeApp(config));
        if (messaging) await deleteToken(messaging);
        activeOwner = null;
        const registration = await navigator.serviceWorker?.getRegistration();
        for (const n of await registration?.getNotifications() || []) n.close();
      }
    }
  });
}
